(function($, undefined) {
  "use strict";
  var
    $window = $(window),
    $title = $("title"),
    viewports = [false, "S", "M", "L", "XL", "XXL"],
    lastWidth = -1,
    lastViewport = viewports[0],
    resize = function() {
      var
        width = $window.width(),
        viewport;
      ///var
      if(width !== lastWidth) {
        viewport = viewports[parseInt($title.css("width"))];
        for(var i = 0, iMax = window.resizedCallback.length; i < iMax; i++)
          window.resizedCallback[i](width, lastWidth, viewport, lastViewport);
        lastWidth = width;
        lastViewport = viewport;
      }
    };

  ///var
  window.resizedCallback = [];
  $window.on("resize", resize);
  $(resize);
})(window.jQuery);

